module.exports = global["Popper"] = require("-!./popper.js");


//////////////////
// WEBPACK FOOTER
// ./~/popper.js/dist/umd/popper.js-exposed
// module id = 127
// module chunks = 114276838955818